import React, { useEffect, useState, useContext } from 'react';
import { Menu, MenuItem, Typography } from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import dashboardStyles from '../Dashboard.style';
import { useNavigate } from 'react-router-dom';
import { colors } from 'theme/color-palette';
import { getPersona } from 'helper/helper';
import { UserPortalContext } from 'context/appcontext';
import { FEATURES } from 'helper/basicFeatureFlag';
import { useDispatch } from 'react-redux';
import {
	getTempates,
	getCustomAttribute,
	getCustomDatasetDetails,
	getCannedReports
} from 'components/Template/Template.actions';
import { PERSONA } from 'constants/constant';
const { LIGHT_GREY } = colors;

function Persona(props) {
	const { openPersonaSelection, setOpenPersonaSelection } = props;
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [anchorEl, setAnchorEl] = useState(null);
	const personas = ['Category Advisor', 'Standard User'];
	const portalUserContext = useContext(UserPortalContext);
	const { updateUserPersona, customerType, userDetails } = portalUserContext;
	const { companyName, catManUser } = userDetails?.result;
	const classes = dashboardStyles();
	const { DISABLE_STD_USER_PERSONA: disableStdUser } = FEATURES[customerType].DASHBOARD;

	const handleSelect = (val) => {
		const _persona = getPersona(val, customerType);
		updateUserPersona(_persona);
		if (_persona === PERSONA.SUPPLIER) {
			dispatch(getTempates({ catManUser, companyName, selectedPersona: _persona }));
			dispatch(getCustomDatasetDetails({ catManUser, companyName, selectedPersona: _persona }));
			dispatch(getCustomAttribute({ catManUser, companyName, selectedPersona: _persona }));
			dispatch(getCustomDatasetDetails({ catManUser, companyName, selectedPersona: _persona }));
			dispatch(getCannedReports({ catManUser, companyName, selectedPersona: _persona }));
		}
		navigate({
			pathname: '/rbtemplates',
			search: '?notReset=true'
		});
	};

	const handleClose = (event) => {
		stopPropagation(event);
		setAnchorEl(null);
		setOpenPersonaSelection(null);
	};

	const stopPropagation = (event) => {
		event?.stopPropagation();
	};

	const handleOpen = () => {
		setAnchorEl(openPersonaSelection);
	};

	useEffect(() => {
		if (openPersonaSelection) {
			handleOpen();
		}
	}, [openPersonaSelection]);

	return (
		<Menu
			id={`persona-items`}
			anchorEl={anchorEl}
			elevation={1}
			style={{ marginTop: 56 }}
			PaperProps={{
				style: {
					width: 203,
					boxShadow: `0 4px 8px 0 ${LIGHT_GREY}, 0 6px 20px 0 ${LIGHT_GREY}`
				}
			}}
			MenuListProps={{
				'aria-labelledby': 'basic-button'
			}}
			open={Boolean(anchorEl)}
			onClose={handleClose}>
			{personas.map((item) => {
				const disableMenuItem = item === 'Standard User' && disableStdUser;
				return (
					<MenuItem
						key={item}
						id={item.replace(/ +/g, '_')}
						className={classes.menuItems}
						disabled={disableMenuItem}
						onClick={(e) => {
							e.stopPropagation();
							handleSelect(item);
							setAnchorEl(null);
						}}>
						<Typography>{item}</Typography>
						{disableMenuItem ? <LockOutlinedIcon className={classes.charterOnly} /> : null}
					</MenuItem>
				);
			})}
		</Menu>
	);
}

Persona.propTypes = {};

export default Persona;
